import script from "./HeaderIcons.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeaderIcons.vue?vue&type=script&setup=true&lang=ts"

const cssModules = {}
import style0 from "./HeaderIcons.vue?vue&type=style&index=0&id=bad8e192&module=true&lang=scss"
cssModules["$style"] = style0

import exportComponent from "../../../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.41_vue@3.5.41_typescript@6.0.3__webpack@5.104.1_26e2e5f0dbb25cfbc35c320d4ca41e40/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules]])

export default __exports__